import React, { useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Button from "../../../ui/Button/Button";
import Container from "../../../ui/Container/Container";
import Input from "../../../ui/Input/Input";
import { sendEmail } from "../../../db/users";
import { getReceiversEmail } from "../../../util/email";
import "./TechnicalSupport.css";

function TechnicalSupport() {
  const [supportText, setSupportText] = useState("");
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  function updateInputValueHandler(e) {
    const enteredValue = e.target.value;
    setSupportText(enteredValue);
  }

  async function optionPressed() {
    if (!supportText){
      alert("Debes ingresar un mensaje para soporte técnico")
      return;
    }
    setIsLoading(true); 
    const doctor = authCtx.currentDoctor;
    let message = `<p style="font-weight: bold">Notificador:<p/>
    <p>Nombre: ${doctor.name} ${doctor.lastName} ${doctor.surName}</p>
    <p>Correo electrónico: ${doctor.email}</p>
    <p>Teléfono: ${doctor.cellPhone}</p>
    <p style="font-weight: bold">Mensaje:<p/>
    <p>${supportText}</p>
    `;
    const subject = "ATRARE ADR Sienna Soporte Técnico";
    const receivers = getReceiversEmail(process.env.REACT_APP_SUPPORT_RECEIVERS);
    await sendEmail(subject, message, receivers);
    setIsLoading(false);
    alert("Correo electrónico enviado con éxito");
    navigate("/mainDoctor");
  }

  if (isLoading) {
    return (<p>Cargando...</p>)
  }

  return (
    <Container title={"Soporte técnico"} backNavigation={"/mainDoctor"}>
      <div className="technicalContainer">
        <span className="technicalDescription">
          ¿Tienes dudas sobre el uso de la app? (p.e. ¿qué hacer si no me deja
          ingresar, si me marca error, si al entrar no es mi usuario, etc.)?
        </span>
        <textarea
          value={supportText}
          onChange={updateInputValueHandler}
          autoCompleteType="off"
          style={{
            paddingTop: "10px",
            paddingBottom: "4px",
            marginTop: "6px",
            backgroundColor: "#F27059",
            borderRadius: "4px",
            fontSize: "16px",
            width: "99%",
            border: 0,
            appearance: "none",
            color: "#D3D0D0"
          }}
        >
        </textarea>
        <div className="technicalButtonsContainer">
          <Button onPress={optionPressed}>Envíar</Button>
        </div>
      </div>
    </Container>
  );
}

export default TechnicalSupport;
